// Small enough that bulk actions never burst the API into 429 responses.
export const DEFAULT_REQUEST_CONCURRENCY = 4;

/**
 * Promise.all(items.map(mapper)) with at most `limit` calls in flight.
 *
 * Results keep input order. Every item is attempted; if any call failed, the
 * returned promise rejects with the first error once all calls have settled.
 */
export async function mapWithConcurrency(
  items,
  mapper,
  limit = DEFAULT_REQUEST_CONCURRENCY,
) {
  const list = Array.from(items || []);
  const results = new Array(list.length);
  let firstError = null;
  let hasError = false;
  let nextIndex = 0;

  const worker = async () => {
    while (nextIndex < list.length) {
      const index = nextIndex;
      nextIndex += 1;
      try {
        results[index] = await mapper(list[index], index);
      } catch (error) {
        if (!hasError) {
          hasError = true;
          firstError = error;
        }
      }
    }
  };

  const workerCount = Math.min(Math.max(1, limit), list.length);
  await Promise.all(Array.from({ length: workerCount }, worker));

  if (hasError) throw firstError;
  return results;
}
